import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Fade } from 'react-reveal';
import img from '../../image/about.png'

const About = () => {
    return (
      <Container className="d-flex align-items-center mt-5 pt-5" id="about">
        <Row xs={1} md={2}>
          <Col className="d-flex align-items-center justify-content-center">
            <Fade right>
              <div>
                <h3 className="component-headings pb-2">About me</h3>
                <p>
                  Assalamualaikum. It's Khurshida Jahan Meem. I always love to
                  find solutions and contribute my best to any collaborative
                  environment. I have worked in teams many times for development
                  or programming contest purpose and achieved desired goals as a
                  team. I would love to explore more and gather more knowledge
                  regarding the programming world.{" "}
                </p>
              </div>
            </Fade>
          </Col>
          <Col className="d-flex align-items-center justify-content-center">
            <Fade left>
              <img src={img} alt="" className="img-fluid" />
            </Fade>
          </Col>
        </Row>
      </Container>
    );
};

export default About;